export enum DAILY_CHECK_TYPE {
  EXTENDED = "extended",
  DEFAULT = "default"
}

export enum ENV_FEATURE_FLAG {
  IS_NEW_NAVIGATION = "isNewNavigation",
  IS_LANGUAGE_KEY_VISIBLE = "isLanguageKeyVisible"
}
